import Activity from '../../domain/activity/global/model/Activity';

export default abstract class ActAmountComputator {
  // eslint-disable-next-line no-unused-vars
  constructor(protected activity: Activity) {}

  public abstract compute(): string;
}
